import { useRecoilValue, useSetRecoilState } from "recoil";

import { AddToCurrentlySelectedFilePath } from "../../state/files";
import OpenFolder from "../../icons/folder.svg?react";
import { Orientation } from "../../state/uiAtoms";
import { StyledFile } from "./File";
import { text } from "@quickpoint.me/shared";

export function Folder({ folderName }: { folderName: string }) {
	const addToCurrentlySelectedFilePath = useSetRecoilState(
		AddToCurrentlySelectedFilePath,
	);
	const isInLandscape = useRecoilValue(Orientation) === "landscape";

	const openFolder = (folderName: string) => {
		addToCurrentlySelectedFilePath(folderName);
	};

	return (
		<StyledFile $isInLandscape={isInLandscape} type={"folder"}>
			<div className="blank-section" />
			<div className="blank-section" />
			<div className="file-link">
				<OpenFolder
					aria-label={text.controls.folder}
					aria-hidden="true"
					focusable="false"
					className="file-icon"
				/>
				<div
					className="folder text"
					// biome-ignore lint/a11y/useSemanticElements: <explanation>
					role="button"
					id={`link-to-${folderName}`}
					onClick={() => {
						if (folderName !== null) {
							openFolder(folderName);
						}
					}}
					onKeyDown={(e) => {
						if ((e.key === "Enter" || e.key === " ") && folderName !== null) {
							openFolder(folderName);
						}
					}}
					tabIndex={0}
				>
					{folderName}
				</div>
			</div>
		</StyledFile>
	);
}
